export const localstorageKeys = {
  token: 'token',
  refreshToken: 'refreshToken',
  user: 'user',
  company: 'company',
};
